import React, { ReactNode } from 'react';
import { ErrorMessage, InfoMessage } from './Message';
import * as styles from './styles';

export interface MessagesProps {
  children: ReactNode;
}

function Messages({ children }: MessagesProps) {
  return <div className={styles.messages}>{children}</div>;
}

export { ErrorMessage, InfoMessage };

export default Messages;
